import Refresh from '@material-ui/icons/Refresh'
import {Trans} from 'react-i18next'
import messages from '../../../assets/messages'
import {ErrorCard, ErrorSub, ErrorTitle, RetryButton} from './KpiPanelError.styled'

type KpiPanelErrorProps = {
  /** Re-attempts to derive/fetch the KPI figures. */
  onRetry: () => void
}

/**
 * Failure state for the KPI panel (PT-5716): shown when the figures cannot be derived or fetched,
 * or when a tile throws while rendering. It replaces the tile grid with a clear "KPIs temporarily
 * unavailable" message and a retry action, so the panel never collapses to a blank box or a
 * white-screen in front of a client.
 *
 * @param onRetry - Invoked when the retry button is pressed.
 */
export const KpiPanelError = ({onRetry}: KpiPanelErrorProps) => (
  <ErrorCard role="alert" data-testid="kpi-panel-error">
    <ErrorTitle>
      <Trans {...messages.pammKpiUnavailableTitle} />
    </ErrorTitle>
    <ErrorSub>
      <Trans {...messages.pammKpiUnavailableSub} />
    </ErrorSub>
    <RetryButton type="button" onClick={onRetry} data-testid="kpi-panel-retry">
      <Refresh style={{fontSize: 15}} />
      <Trans {...messages.pammKpiUnavailableRetry} />
    </RetryButton>
  </ErrorCard>
)
